import appendDefaultParamsToRoute from './append-default-params-to-route'

const getRouteWithDefaultParams = (name, params = {}, query = {}) => {
  const route = {
    name,
    params,
    query,
  }
  return appendDefaultParamsToRoute(route)
}

export default getRouteWithDefaultParams
